import smoothscroll from 'smoothscroll-polyfill'

// need polyfill for Safari support, until they support ScrollToOptions: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollBy
smoothscroll.polyfill()

// Smooth scroll on anchor link clicks (source: https://codepen.io/a8t/pen/JOYwLM?editors=0010)
function anchorLinkHandler(e) {
  const distanceToTop = el => Math.floor(el.getBoundingClientRect().top - 110)

  e.preventDefault()
  const targetID = this.getAttribute('href')
  const targetAnchor = document.querySelector(targetID)
  if (!targetAnchor) return
  const originalTop = distanceToTop(targetAnchor)

  window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' })

  const checkIfDone = setInterval(function () {
    const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2
    if (distanceToTop(targetAnchor) === 0 || atBottom) {
      targetAnchor.tabIndex = '-1'
      clearInterval(checkIfDone)
    }
  }, 100)
}

// Polyfill forEach to add compatibility with older browsers that do not support forEach on NodeList objects.
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

document.addEventListener('turbolinks:load', function () {
  const linksToAnchors = document.querySelectorAll('a[href^="#"]')
  linksToAnchors.forEach(each => (each.onclick = anchorLinkHandler))
})
